import { defineComponent as _defineComponent } from 'vue'
import Client from '@/models/Client';
import UserBadge from '@/components/badges/UserBadge.vue';
import GoToService from '@/router/GoToService';
import EnvironmentService from '@/env/EnvironmentService';
import Activity from '@/models/Activity';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientOwnerInfoCard',
  props: {
    message: null,
    client: null
  },
  emits: ["click:goToClientDetails"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click:goToClientDetails'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  message: string,
  client: Client,
}




const isAppDomain = EnvironmentService.Environment.isAppDomain();
const goToClient = () => {
  GoToService.client(props.client.id);
  emit('click:goToClientDetails');
}

return { __sfc: true,props, emit, isAppDomain, goToClient, UserBadge }
}

})